module.exports = __webpack_public_path__ + "img/808.9069d7ad.png";